import * as React from "react";

import Layout from "../../components/Layout";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";

import AccountBoxIcon from "@material-ui/icons/AccountBox";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import ComputerIcon from "@material-ui/icons/Computer";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SmsIcon from "@material-ui/icons/Sms";
import { Paper } from "@material-ui/core";
const HomePage = () => {
  return (
    <div>
      <Layout>
        <Paper>
          <List>
            <ListItem>
              <ListItemIcon button key="0">
                <ComputerIcon />
              </ListItemIcon>
              <ListItemText primary="서버현황 - 기관별 서버 현황을 확인하고 수정합니다." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <SmsIcon />
              </ListItemIcon>
              <ListItemText primary="SMS - 기관별 SMS 발송량을 확인합니다." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <LocationCityIcon />
              </ListItemIcon>
              <ListItemText primary="기관관리 - Data 확인용으로 실제 사용되진 않습니다." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AccountBoxIcon />
              </ListItemIcon>
              <ListItemText primary="사용자관리 - 사용자 및 추가 삭제" />
            </ListItem>
          </List>
        </Paper>
      </Layout>
    </div>
  );
};

export default HomePage;
